import React from 'react';
import PropTypes from 'prop-types';
import { Paper, styled } from '@mui/material';

export const ResponsivePaper = (props) => {
  const StyledPaper = styled(Paper)(({ theme }) => ({
    padding: theme.spacing(1),
    margin: 'auto',
    flexGrow: 1,
    width: '650px',
    height: '100%',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  }));

  return <StyledPaper>{props.children}</StyledPaper>;
};

// Prop validation
ResponsivePaper.propTypes = {
  children: PropTypes.node,
};
